import api from './api';

const queueService = {
  async getQueues() {
    try {
      const response = await api.get('/api/queues');
      // Normalizar para sempre retornar array
      if (Array.isArray(response)) return response;
      if (response?.data && Array.isArray(response.data)) return response.data;
      if (response?.queues && Array.isArray(response.queues)) return response.queues;
      return [];
    } catch (error) {
      console.error('Erro ao buscar filas:', error);
      throw error;
    }
  },

  async getQueue(id) {
    try {
      const response = await api.get(`/api/queues/${id}`);
      return response?.data ?? response;
    } catch (error) {
      console.error('Erro ao buscar fila:', error);
      throw error;
    }
  },

  async createQueue(queueData) {
    try {
      const response = await api.post('/api/queues', queueData);
      return response?.data ?? response;
    } catch (error) {
      console.error('Erro ao criar fila:', error);
      throw error;
    }
  },

  async updateQueue(id, queueData) {
    try {
      const response = await api.put(`/api/queues/${id}`, queueData);
      return response?.data ?? response;
    } catch (error) {
      console.error('Erro ao atualizar fila:', error);
      throw error;
    }
  },

  async deleteQueue(id) {
    try {
      const response = await api.delete(`/api/queues/${id}`);
      return response?.data ?? response;
    } catch (error) {
      console.error('Erro ao deletar fila:', error);
      throw error;
    }
  }
};

export default queueService;